import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-multilinegraph',
  templateUrl: './multilinegraph.component.html',
  styleUrls: ['./multilinegraph.component.scss']
})
export class MultilinegraphComponent {
  //chartData: any;
  @Input() data: any;

  startDate: Date  = new Date('09-09-2023');
  endDate: Date = new Date();
  today: Date = new Date();
  limit: number = 10;
  graphData: any;

  constructor(private dataService: DataService) {}

  async ngOnInit() {
    // Fetch data from your MongoDB aggregation query using a service
    this.graphData = await this.getDataFromArg(this.startDate, this.endDate, this.limit);
    this.chartData = await this.makeChart(this.graphData);

    this.chartOptions = {
      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'dd-mm-yyyy'
              },
            },
            scaleLabel: {
              display: true,
              labelString: 'Date'
            }
          }
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: 'count'
            }
          }
        ],
        x: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic'
            },  color :'white'
          }
        },
        y: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic'
            } , color :'white'
          }
        }
      },
      plugins: {
        title: {
          display: true,
          text: this.data.graphname,
          font: {
            family: 'SSTArabic'
          }
        },
        legend: {
          labels: {
            font: {
              size: 14,
              family: 'SSTArabic'
            }, color :'white'
          }
        }
      }
    };

  }
  async makeChart(graphData: any) {

    const dateArray = await this.generateDateArray(this.startDate, this.endDate);

    const graphDataPromises = graphData.map(async (item: { _id: string | null, data: { key: string, count: number }[] }) => {
      const data = await this.putDateInArray(dateArray, item.data);
      return {
        label: item._id,
        data: data,
        fill: false
      };
    });

    const graphDataResolved = await Promise.all(graphDataPromises);

    const chart = {
      labels: dateArray,
      datasets: graphDataResolved
    };

    return chart;
  }

  async putDateInArray(dateArray: string[], data: { key: string; count: number; }[]) {
    const arr = new Array(dateArray.length).fill(0); // Initialize arr with zeros

    await data.forEach(item => {
      const index = dateArray.indexOf(item.key); // Find the index of item.key in dateArray
      if (index !== -1) {
        arr[index] = item.count; // Set the value at the same index in arr
      }
    });

    return arr;
  }


  async getDataFromArg(startDate?: Date, endDate?: Date, limit: number = 10) {

    // let res = await this.dataService.postData('dashboards/dynamic-aggregation', {
    //   "aggregation": this.data.aggregation,
    //   "tableName": this.data.table,
    //   "timeRange":  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
    //   "limit": limit
    // }); 

    // return res.data;

    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (this.data.tag && this.data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: this.data.aggregation,
          tableName: this.data.table,
          timeRange: (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          managerOus: managerOu,
          pre_arg: this.data.pre_arg ? this.data.pre_arg : null,
          limit: limit
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: this.data.aggregation,
          tableName: this.data.table,
          timeRange:  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          pre_arg: this.data.pre_arg ? this.data.pre_arg : null,
          limit: limit
        }
      );
      return res.data;
    }
  }

  async onLimitChange() {

    this.graphData = await this.getDataFromArg(this.startDate, this.endDate, this.limit);
    this.chartData = await this.makeChart(this.graphData)
    
  }

  async onDateChange() {
    this.graphData = await this.getDataFromArg(this.startDate, this.endDate, this.limit);
    this.chartData = await this.makeChart(this.graphData)
  }

  async generateDateArray(startDate: Date, endDate: Date) {
    const dateArray = [];
    const currentDate = new Date(startDate);
  
    while (currentDate <= endDate) {
      const day = currentDate.getDate().toString().padStart(2, '0');
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
      const year = currentDate.getFullYear();
      const dateString = `${day}-${month}-${year}`;
      dateArray.push(dateString);
  
      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }
  
    return dateArray;
  }



  chartOptions: any = {
    scales: {
      xAxes: [
        {
          type: 'time',
          time: {
            unit: 'day',
            displayFormats: {
              day: 'dd-mm-yyyy'
            },
          },
          scaleLabel: {
            display: true,
            labelString: 'Date'
          }
        }
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'count'
          }
        }
      ]
    }
  };

  chartData = {
    "labels": [
        "09-09-2023",
    ],
    "datasets": [
        {
            "label": "Loading",
            "data": [
                0,
            ],
            "fill": false
        },
        
    ]
}
}